module.exports = __webpack_public_path__ + "img/609_manheim_identity_ca_3000px.png.ec73877d.png";